/**
 * Scratch Card Popup for Shopify
 * Flow: 1. Scratch & win → 2. Enter email → 3. Code via email (Klaviyo)
 * Uses SVG assets for the scratch surface and prize display.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'h420_scratch_card_used';
    var root = document.getElementById('scratch-card-popup');
    if (!root) return;

    var config = {
        delay: parseInt(root.dataset.delay || '18', 10) * 1000,
        showAgainAfter: parseInt(root.dataset.showAgainAfter || '30', 10),
        enabled: root.dataset.enabled === 'true',
        showAlways: root.dataset.showAlways === 'true',
        // Klaviyo
        klaviyoCompany: root.dataset.klaviyoCompany || '',
        klaviyoList: root.dataset.klaviyoList || '',
        klaviyoEvent: root.dataset.klaviyoEvent || 'Scratch Card Won',
        klaviyoSms: root.dataset.klaviyoSms === 'true'
    };

    if (!config.enabled) return;

    // Check localStorage
    if (!config.showAlways) {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                var parsed = JSON.parse(stored);
                if (parsed.expires && new Date().getTime() < parsed.expires) return;
            } catch (e) { /* corrupted */ }
        }
    }

    // Parse prizes (now includes SVG URL per prize)
    var prizeElements = root.querySelectorAll('.scratch-card--prize-data');
    var prizes = [];
    prizeElements.forEach(function (el) {
        prizes.push({
            code: el.dataset.code || '',
            label: el.dataset.label || '',
            url: el.dataset.url || '',
            weight: parseInt(el.dataset.weight || '20', 10),
            prizeSvg: el.dataset.prizeSvg || ''
        });
    });
    if (prizes.length === 0) return;

    function selectPrize() {
        var total = 0;
        for (var i = 0; i < prizes.length; i++) total += prizes[i].weight;
        var rand = Math.random() * total;
        var cum = 0;
        for (var j = 0; j < prizes.length; j++) {
            cum += prizes[j].weight;
            if (rand <= cum) return prizes[j];
        }
        return prizes[prizes.length - 1];
    }

    var selectedPrize = selectPrize();

    // DOM
    var overlay = root.querySelector('.scratch-card--overlay');
    var closeBtn = root.querySelector('.scratch-card--close');
    var canvas = root.querySelector('.scratch-card--canvas');
    var prizeSvgImg = root.querySelector('.scratch-card--prize-svg');
    var emailInputs = root.querySelectorAll('.scratch-card--email-input');
    var emailInput = emailInputs[0];
    var emailErrors = root.querySelectorAll('.scratch-card--email-error');
    var emailError = emailErrors[0];
    var formAreas = root.querySelectorAll('.scratch-card--form-area');
    var stepsEl = root.querySelector('.scratch-card--steps');
    var instructionsEl = root.querySelector('.scratch-card--instructions');
    var instructionsElmobile = root.querySelector('.scratch-card--instructions.sc--mobile');
    var confirmEl = root.querySelector('.scratch-card--confirm');
    var successArea = root.querySelector('.scratch-card--success');
    var successPrize = root.querySelector('.scratch-card--success-prize');
    var step1 = root.querySelector('.scratch-card--step-1');
    var step2 = root.querySelector('.scratch-card--step-2');
    var step3 = root.querySelector('.scratch-card--step-3');
    var arrowEl = root.querySelector('.scratch-card--arrow');
    var okButtons = root.querySelectorAll('.scratch-card--email-ok');

    // State
    var isScratching = false;
    var revealed = false;
    var emailSubmitted = false;

    // Set prize SVG image
    if (prizeSvgImg && selectedPrize.prizeSvg) {
        prizeSvgImg.src = selectedPrize.prizeSvg;
        prizeSvgImg.alt = selectedPrize.label;
        prizeSvgImg.style.display = 'block';
    }

    if (successPrize) {
        successPrize.innerHTML = 'You won <strong>' + selectedPrize.label + '</strong>! Check your email for your discount code.';
    }

    // Highlight active step
    function setActiveStep(num) {
        [step1, step2, step3].forEach(function (el, i) {
            if (!el) return;
            if (i + 1 === num) {
                el.classList.add('is-active');
            } else {
                el.classList.remove('is-active');
            }
            if (i + 1 < num) {
                el.classList.add('is-done');
            }
        });
    }

    // Canvas init — draw ScratchButton SVG as the scratch surface
    function initCanvas() {
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        if (!ctx) return;

        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var surfaceSvgUrl = (isMobile && canvas.dataset.surfaceSvgMobile)
            ? canvas.dataset.surfaceSvgMobile
            : canvas.dataset.surfaceSvg;

        if (surfaceSvgUrl) {
            // Load SVG as an image and draw it onto the canvas
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
                // Clip to circle
                ctx.save();
                ctx.beginPath();
                ctx.arc(75, 75, 75, 0, Math.PI * 2);
                ctx.clip();

                // Draw the SVG image scaled to fill the canvas
                ctx.drawImage(img, 0, 0, 150, 150);
                ctx.restore();
            };
            img.onerror = function () {
                // Fallback: solid circle fill
                drawFallbackSurface(ctx);
            };
            img.src = surfaceSvgUrl;
        } else {
            drawFallbackSurface(ctx);
        }
    }

    function drawFallbackSurface(ctx) {
        var bgColor = root.dataset.overlayColor || '#9ca3af';
        ctx.fillStyle = bgColor;
        ctx.beginPath();
        ctx.arc(75, 75, 75, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 14px sans-serif';
        ctx.textAlign = 'center';
        ctx.save();
        ctx.translate(75, 45);
        ctx.rotate(-0.3);
        ctx.fillText('HAPPY420', 0, 0);
        ctx.restore();

        ctx.strokeStyle = '#1f2937';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(75, 85, 25, 0.1 * Math.PI, 0.9 * Math.PI);
        ctx.stroke();
    }

    function scratch(x, y) {
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, 20, 0, Math.PI * 2);
        ctx.fill();

        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var transparent = 0;

        for (var py = 0; py < canvas.height; py++) {
            for (var px = 0; px < canvas.width; px++) {
                var dx = px - 75;
                var dy = py - 75;
                if (dx * dx + dy * dy <= 75 * 75) {
                    var i = (py * canvas.width + px) * 4;
                    if (pixels[i + 3] === 0) transparent++;
                }
            }
        }

        var circleArea = Math.PI * 75 * 75;
        var percentage = (transparent / circleArea) * 100;

        if (percentage > 65 && !revealed) {
            revealed = true;
            onPrizeRevealed();
        }
    }

    // --- PHASE 1: Prize revealed (after scratching) — show email form ---
    function onPrizeRevealed() {
        // Step 2 active (enter email)
        setActiveStep(2);

        // Hide arrow
        if (arrowEl) arrowEl.style.display = 'none';

        // Show email form areas (they start hidden)
        formAreas.forEach(function (el) {
            el.style.display = '';
            el.classList.add('is-revealed');
        });

        // On mobile: show the mobile email inside instructions
        if (instructionsElmobile) {
            var mobileForm = instructionsElmobile.querySelector('.scratch-email-mobile');
            if (mobileForm) {
                mobileForm.style.display = '';
                mobileForm.classList.add('is-revealed');
            }
        }

        // Auto-focus the visible email input
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        emailInputs.forEach(function (inp) {
            var isInMobile = inp.closest('.scratch-email-mobile');
            if (isMobile && isInMobile) inp.focus();
            if (!isMobile && !isInMobile) inp.focus();
        });

        // Set localStorage (mark as used even if they don't enter email)
        var expiry = new Date();
        expiry.setDate(expiry.getDate() + config.showAgainAfter);
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            expires: expiry.getTime(),
            code: selectedPrize.code
        }));
    }

    // --- PHASE 2: Email confirmed (after OK button) — fire Klaviyo ---
    function onEmailConfirmed() {
        if (emailSubmitted) return;

        var email = '';
        emailInputs.forEach(function (inp) {
            if (inp.value.trim()) email = inp.value.trim();
        });

        if (!validateEmail(email)) {
            emailErrors.forEach(function (el) { el.style.display = 'block'; });
            emailInputs.forEach(function (el) { el.classList.add('is-invalid'); });
            return;
        }

        emailSubmitted = true;

        // Step 3 active
        setActiveStep(3);

        // --- Fire Klaviyo ---
        var _learnq = window._learnq || [];

        var consent = ['email'];
        if (config.klaviyoSms) consent.push('sms');

        _learnq.push(['identify', {
            '$email': email,
            '$consent': consent,
            'Scratch Card Code': selectedPrize.code,
            'Scratch Card Prize': selectedPrize.label
        }]);

        _learnq.push(['track', config.klaviyoEvent, {
            'Code': selectedPrize.code,
            'Label': selectedPrize.label,
            'Discount URL': selectedPrize.url,
            'Email': email
        }]);

        // --- Klaviyo List Subscription via Client API ---
        if (config.klaviyoCompany && config.klaviyoList && email) {
            var subBody = {
                data: {
                    type: 'subscription',
                    attributes: {
                        custom_source: 'Scratch Card Popup',
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: email,
                                    properties: {
                                        'Scratch Card Code': selectedPrize.code,
                                        'Scratch Card Prize': selectedPrize.label,
                                        'Scratch Card Discount URL': selectedPrize.url
                                    }
                                }
                            }
                        }
                    },
                    relationships: {
                        list: {
                            data: {
                                type: 'list',
                                id: config.klaviyoList
                            }
                        }
                    }
                }
            };

            console.log('[Scratch Card] Subscribing to Klaviyo list:', config.klaviyoList, 'email:', email);

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + config.klaviyoCompany, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'revision': '2024-10-15'
                },
                body: JSON.stringify(subBody)
            }).then(function (res) {
                console.log('[Scratch Card] Klaviyo response status:', res.status);
                if (!res.ok) {
                    return res.text().then(function (t) {
                        console.error('[Scratch Card] Klaviyo error body:', t);
                    });
                }
            }).catch(function (err) {
                console.warn('[Scratch Card] Klaviyo subscription error:', err);
            });
        } else {
            console.warn('[Scratch Card] Klaviyo subscription skipped — company:', config.klaviyoCompany, 'list:', config.klaviyoList, 'email:', email);
        }

        // --- Hide steps + form, show confirmation ---
        if (stepsEl) stepsEl.style.display = 'none';
        if (instructionsEl) instructionsEl.classList.add('is-hidden');
        formAreas.forEach(function (el) { el.style.display = 'none'; });
        if (emailError) emailError.style.display = 'none';
        emailErrors.forEach(function (el) { el.style.display = 'none'; });
        if (confirmEl) {
            confirmEl.style.display = 'block';
        }
    }

    function getCanvasCoords(e) {
        if (!canvas) return { x: 0, y: 0 };
        var rect = canvas.getBoundingClientRect();
        var scaleX = canvas.width / rect.width;
        var scaleY = canvas.height / rect.height;
        if (e.touches && e.touches.length > 0) {
            return {
                x: (e.touches[0].clientX - rect.left) * scaleX,
                y: (e.touches[0].clientY - rect.top) * scaleY
            };
        }
        return {
            x: (e.clientX - rect.left) * scaleX,
            y: (e.clientY - rect.top) * scaleY
        };
    }

    // No email gate — scratch immediately
    function handleStart(e) {
        if (revealed) return; // already revealed, stop scratching
        e.preventDefault();
        isScratching = true;
        scratch(getCanvasCoords(e).x, getCanvasCoords(e).y);
    }

    function handleMove(e) {
        if (!isScratching || revealed) return;
        e.preventDefault();
        scratch(getCanvasCoords(e).x, getCanvasCoords(e).y);
    }

    function handleEnd() {
        isScratching = false;
    }

    // Canvas events
    if (canvas) {
        canvas.addEventListener('mousedown', handleStart);
        canvas.addEventListener('touchstart', handleStart, { passive: false });

        document.addEventListener('mousemove', handleMove);
        document.addEventListener('mouseup', handleEnd);
        document.addEventListener('touchmove', handleMove, { passive: false });
        document.addEventListener('touchend', handleEnd);
    }

    // Email validation
    function validateEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    // Sync value across all email inputs (desktop + mobile)
    function syncEmailInputs(source) {
        emailInputs.forEach(function (inp) {
            if (inp !== source) inp.value = source.value;
        });
    }

    // Attach listeners to email inputs — just sync + clear errors on valid
    emailInputs.forEach(function (inp) {
        inp.addEventListener('input', function () {
            syncEmailInputs(inp);
            if (validateEmail(inp.value)) {
                emailErrors.forEach(function (el) { el.style.display = 'none'; });
                emailInputs.forEach(function (el) { el.classList.remove('is-invalid'); });
            }
        });

        // Submit on Enter key
        inp.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                onEmailConfirmed();
            }
        });
    });

    // OK button click handlers
    okButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            onEmailConfirmed();
        });
    });

    // Open / Close
    var wrapper = root.querySelector('.scratch-card--wrapper');

    function scaleMobileCard() {
        if (!wrapper) return;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (!isMobile) {
            wrapper.style.width = '';
            wrapper.style.height = '';
            return;
        }
        var NATURAL_W = 340;
        var NATURAL_H = 726.5;
        var overlayPad = 32;
        var availW = window.innerWidth - overlayPad;
        var availH = window.innerHeight * 0.88;
        var scale = Math.min(availW / NATURAL_W, availH / NATURAL_H, 1);
        wrapper.style.width = Math.round(NATURAL_W * scale) + 'px';
        wrapper.style.height = Math.round(NATURAL_H * scale) + 'px';
    }

    function openPopup() {
        scaleMobileCard();
        if (overlay) overlay.classList.add('is-visible');
    }

    window.addEventListener('resize', function () {
        if (overlay && overlay.classList.contains('is-visible')) scaleMobileCard();
    });

    function closePopup() {
        if (overlay) overlay.classList.remove('is-visible');
        if (!localStorage.getItem(STORAGE_KEY)) {
            var expiry = new Date();
            expiry.setDate(expiry.getDate() + config.showAgainAfter);
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                expires: expiry.getTime(),
                code: null
            }));
        }
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closePopup();
        });
    }

    if (overlay) {
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) closePopup();
        });
    }

    // Init — canvas starts UNLOCKED (no is-locked class)
    initCanvas();
    if (successArea) successArea.style.display = 'none';
    setActiveStep(1);

    // Hide email forms at start (they appear only after prize reveal)
    formAreas.forEach(function (el) { el.style.display = 'none'; });

    setTimeout(openPopup, config.delay);

    // Theme editor
    if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', function (e) {
            if (e.target === root || root.contains(e.target)) openPopup();
        });
        document.addEventListener('shopify:section:deselect', function (e) {
            if (e.target === root || root.contains(e.target)) closePopup();
        });
    }
})();
